module.exports = __webpack_public_path__ + "static/img/list_lw.1349c9ae.png";